type Validator = (value: string) => string | undefined;

export const validateRequired = (
  message: string,
) => (value: string) => (!value ? message : undefined);

export const validateRegexp = (
  regExp: RegExp | string,
  message: string,
) => (value: string) => (value && !value.match(regExp) ? message : undefined);

export const composeValidators = (
  ...validators: Validator[]
) => (
  value: string,
) => validators.reduce(
  (error: string | undefined, validator: Validator) => error || validator(value),
  undefined,
);
